<template>
  <section>
    <div class="container">
      <h2>
        Profile
      </h2>
      <p>
        aaa
      </p>
    </div>
  </section>
</template>

<script>
    export default {
        name: 'top',
        title: 'Top', // title 追加
        description: ' ポートフォリオサイト ', // description 追加
        props: ['data']
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Profile.vue